// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__U8AiP","itemTitle":"ClientEmergencyInfo_itemTitle__SD1Ni","itemText":"ClientEmergencyInfo_itemText__26x8T"};